export const getProductCharacteristics = (id: string) => ({
  type: "@saga/GET_PRODUCT_CHARACTERISTICS",
  payload: id,
});
